export default "__VITE_ASSET__BHzptqJk__"